import { MouseEvent, useState } from 'react'
import { ModalBarcodePrinting } from '~/features/products/crud/product-general/Modal-barcode-printing'
import { OptionDetails, ProductsService } from '~/shared/api'
import { formatErrorForToast, useToast } from '~/shared/lib'
import { SVGPrint } from '~/shared/ui/SVG/SVGPrint'
import Spinner from '~/shared/ui/spinner'

interface PrintBarcodeModalButtonProps {
  id: string
  className?: string
  iconColor?: string
  iconSize?: string
}

export const PrintBarcodeModalButton = ({
  id,
  className = '',
  iconColor = '#242424',
  iconSize = '24',
}: PrintBarcodeModalButtonProps) => {
  const toast = useToast()
  const [isOpen, setIsOpen] = useState(false)
  const [options, setOptions] = useState<OptionDetails[]>([])
  const [isLoading, setIsLoading] = useState(false)

  const handleOpen = async (event: MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
    event.stopPropagation()

    try {
      setIsLoading(true)
      const { data } = await ProductsService.getOptionsDetail(id)
      setOptions(data.options)
      setIsOpen(true)
    } catch (error) {
      toast.open(formatErrorForToast(error), 'danger')
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <>
      <button
        aria-label="Распечатать стикер"
        className={`opacity-0 group-hover:opacity-100 focus-visible:opacity-100 transition-opacity cursor-pointer disabled:cursor-not-allowed disabled:opacity-60 ${className}`.trim()}
        disabled={isLoading}
        onClick={handleOpen}
        type="button"
      >
        {isLoading ? (
          <Spinner className="w-5 h-5" />
        ) : (
          <SVGPrint color={iconColor} size={iconSize} />
        )}
      </button>
      <ModalBarcodePrinting
        id={id}
        isOpen={isOpen}
        onClose={(event) => {
          event.preventDefault()
          setIsOpen(false)
        }}
        options={options}
      />
    </>
  )
}
